import { createContext, useContext, useMemo, useState } from "react";

const ParticipateChromeContext = createContext(null);

export function ParticipateChromeProvider({ children }) {
  const [participateHeaderLine, setParticipateHeaderLine] = useState(null);
  const value = useMemo(
    () => ({ participateHeaderLine, setParticipateHeaderLine }),
    [participateHeaderLine],
  );
  return (
    <ParticipateChromeContext.Provider value={value}>{children}</ParticipateChromeContext.Provider>
  );
}

export function useParticipateChrome() {
  const ctx = useContext(ParticipateChromeContext);
  if (!ctx) return { participateHeaderLine: null, setParticipateHeaderLine: () => {} };
  return ctx;
}
